import i18n from "@/i18n";
import ChartService from "@/services/charts/ChartService";
import WDService from "@/services/wind/diagnostic/WindDiagnosticService";
import { httpV2 } from "@/api/index";
import { SetLayoutLinesColor } from "@/components/charts/ChartStyles";
import GenShaftModel from "@/models/wind-diagnostic/GeneratorShaftUnbalanceModel";
import {
	GET_GEN_SHAFT_UNBALANCE_RESULT,
	RESET_GEN_SHAFT_UNBALANCE_RESULT,
	GET_GEN_SHAFT_UNBALANCE_CHART,
} from "./GeneratorShaftUnbalanceActionTypes.js";
import FetchStatus from "@/constants/fetch-status/FetchStatus";
import { DiagnosticRange } from "@/constants/enums/DiagnosticRange";

const actions = {
	[GET_GEN_SHAFT_UNBALANCE_RESULT]: ({ commit }, resultSetId) => new Promise((resolve, reject) =>
	{
		const generatorShaftStateModel = GenShaftModel.GeneratorShaftStateModel();
		generatorShaftStateModel.status = FetchStatus.Loading;
		commit(GET_GEN_SHAFT_UNBALANCE_RESULT, generatorShaftStateModel);

		httpV2.get(`/WindTurbinesDiagnostic/${resultSetId}/UnbalanceGenerator`)
			.then((response) =>
			{
				const result = GenShaftModel.GeneratorShaftStateModel();
				result.status = FetchStatus.Loaded;
				result.operatingRange = response.data.operatingRange;
				result.signalSettingIds = response.data.signalSettingIds;

				commit(GET_GEN_SHAFT_UNBALANCE_RESULT, result);
				resolve(response);
			})
			.catch((error) =>
			{
				const result = GenShaftModel.GeneratorShaftStateModel();
				result.status = FetchStatus.Error;
				result.operatingRange = DiagnosticRange.undefined;
				result.error = error.status;
				result.errorMessage = error.errorMessage;

				commit(GET_GEN_SHAFT_UNBALANCE_RESULT, result);
				reject(error);
			});
	}),

	[GET_GEN_SHAFT_UNBALANCE_CHART]: ({ commit }, parameters) => new Promise((resolve, reject) =>
	{
		const model = GenShaftModel.GeneratorShaftStateModel();
		model.status = FetchStatus.Loading;

		commit(GET_GEN_SHAFT_UNBALANCE_CHART, model);

		httpV2.get(`/WindTurbinesDiagnostic/${parameters.resultSetId}/UnbalanceGenerator/Chart`)
			.then((response) =>
			{
				response.data.unbalanceGeneratorShaftChartData.sort((a, b) =>
				{
					const nameA = a.name.toUpperCase();
					const nameB = b.name.toUpperCase();
					if (nameA < nameB)
					{
						return -1;
					}
					if (nameA > nameB)
					{
						return 1;
					}
					return 0;
				});
				const orderChartData = WDService.CreateChart(response.data.unbalanceGeneratorShaftChartData, true);
				const orderLayout = SetLayoutLinesColor(
					GenShaftModel.GeneratorShaftUnbalanceLayoutModel(),
					parameters.isDarkMode
				);

				const frequencyChartData = WDService.CreateChart(response.data.unbalanceGeneratorShaftChartData, false);
				const frequencyLayout = SetLayoutLinesColor(
					GenShaftModel.GeneratorShaftUnbalanceLayoutModel(),
					parameters.isDarkMode
				);

				orderLayout.shapes = ChartService.CreateAnnotations(response.data.concernOrders);
				orderLayout.annotations = ChartService
					.CreateAnnotationText(response.data.concernOrders, parameters.isDarkMode, "GEN");

				frequencyLayout.shapes = ChartService.CreateAnnotations(response.data.concernFrequencies);
				frequencyLayout.annotations = ChartService
					.CreateAnnotationText(response.data.concernFrequencies, parameters.isDarkMode, "GEN");
				frequencyLayout.xaxis.title = i18n.t("Labels.FrequencyXAxisName");

				const resp = GenShaftModel.GeneratorShaftStateModel();
				resp.status = FetchStatus.Loaded;
				resp.orderChartData = orderChartData;
				resp.orderLayout = orderLayout;
				resp.frequencyChartData = frequencyChartData;
				resp.frequencyLayout = frequencyLayout;

				commit(GET_GEN_SHAFT_UNBALANCE_CHART, resp);
				resolve(resp);
			})
			.catch((error) =>
			{
				const result = GenShaftModel.GeneratorShaftStateModel();
				result.status = FetchStatus.Error;
				result.operatingRange = DiagnosticRange.undefined;
				result.error = error.status;
				result.errorMessage = error.errorMessage;

				commit(GET_GEN_SHAFT_UNBALANCE_CHART, error);
				reject(error);
			});
	}),

	[RESET_GEN_SHAFT_UNBALANCE_RESULT]: ({ commit }) =>
	{
		commit(RESET_GEN_SHAFT_UNBALANCE_RESULT, GenShaftModel.GeneratorShaftStateModel());
	},
};

export default { actions };
